/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
export class GitManager {
    constructor(historian) {
        this.historian = historian;
    }
    /**
     * Reads the object with the given ID. We defer to the client implementation to do the actual read.
     */
    async getCommits(sha, count) {
        return this.historian.getCommits(sha, count);
    }
    /**
     * Reads the object with the given ID. We defer to the client implementation to do the actual read.
     */
    async getTree(root, recursive = true) {
        return this.historian.getTree(root, recursive);
    }
    async getBlob(sha) {
        return this.historian.getBlob(sha);
    }
    async createBlob(content, encoding) {
        const blob = {
            content,
            encoding,
        };
        return this.historian.createBlob(blob);
    }
    async createGitTree(params) {
        const treeP = this.historian.createTree(params);
        return treeP;
    }
    async createSummary(summary, initial = false) {
        return this.historian.createSummary(summary, initial);
    }
    async getSnapshot(sha) {
        return this.historian.getSnapshot(sha);
    }
}
//# sourceMappingURL=gitManager.js.map